import {
  useMemo,
  useState,
} from "react";

import type {
  Client,
} from "../../clientes/types";

import "./ClientAutocomplete.css";

type ClientAutocompleteProps = {
  clients: Client[];

  value: string;

  selectedClient:
    | Client
    | null;

  onChange: (
    value: string,
  ) => void;

  onSelect: (
    client: Client,
  ) => void;

  onRequestCreate: (
    suggestedName: string,
  ) => void;
};

export default function ClientAutocomplete({
  clients,
  value,
  selectedClient,
  onChange,
  onSelect,
  onRequestCreate,
}: ClientAutocompleteProps) {
  const [
    focused,
    setFocused,
  ] =
    useState(false);

  const suggestions =
    useMemo(() => {
      const term =
        value
          .trim()
          .toLowerCase();

      if (!term) {
        return [];
      }

      return clients
        .filter(
          (client) =>
            client.nome
              .toLowerCase()
              .includes(term) ||
            (
              client.telefone ||
              ""
            )
              .toLowerCase()
              .includes(term),
        )
        .slice(0, 6);
    }, [
      clients,
      value,
    ]);

  const exactMatch =
    clients.some(
      (client) =>
        client.nome
          .trim()
          .toLowerCase() ===
        value
          .trim()
          .toLowerCase(),
    );

  const showResults =
    focused &&
    value.trim().length > 0 &&
    !selectedClient;

  return (
    <div className="client-autocomplete">
      <input
        autoFocus
        value={value}
        onFocus={() =>
          setFocused(true)
        }
        onChange={(
          event,
        ) => {
          onChange(
            event.target.value,
          );

          setFocused(true);
        }}
        placeholder="Digite nome ou telefone"
      />

      {selectedClient && (
        <div className="selected-client">
          <div>
            <strong>
              ✓ {selectedClient.nome}
            </strong>

            <span>
              {selectedClient.telefone ||
                "Sem telefone"}
            </span>
          </div>

          <small>
            {selectedClient.nivel ||
              "Sem nível"}
          </small>
        </div>
      )}

      {showResults && (
        <div className="client-suggestions">
          {suggestions.map(
            (client) => (
              <button
                type="button"
                key={client.id}
                onMouseDown={(
                  event,
                ) =>
                  event.preventDefault()
                }
                onClick={() => {
                  onSelect(
                    client,
                  );

                  setFocused(
                    false,
                  );
                }}
              >
                <div>
                  <strong>
                    {
                      client.nome
                    }
                  </strong>

                  <span>
                    {client.telefone ||
                      "Sem telefone"}
                  </span>
                </div>

                <small>
                  {client.nivel ||
                    "Sem nível"}
                </small>
              </button>
            ),
          )}

          {!exactMatch && (
            <button
              type="button"
              className="quick-create-client"
              onMouseDown={(
                event,
              ) =>
                event.preventDefault()
              }
              onClick={() => {
                onRequestCreate(
                  value.trim(),
                );

                setFocused(
                  false,
                );
              }}
            >
              <strong>
                + Cadastrar
                {" "}
                “{value.trim()}”
              </strong>

              <span>
                Criar cliente sem
                sair da reserva
              </span>
            </button>
          )}

          {suggestions.length ===
            0 &&
            exactMatch && (
              <div className="no-client-results">
                Nenhum outro
                cliente encontrado.
              </div>
            )}
        </div>
      )}
    </div>
  );
}